const sessionTypes = {
	LIVE_SESSION: 0,
	HOMEWORK: 1,
	EMBED: 2,
	PREVIEW: 3,
	TEACHER_STUDENT_VIEW: 4,
	CANVAS: 5,
	FRONT_OF_CLASSROOM: 6,
	UNSET: 99,
}

export const sessionTypeNames = {
	[sessionTypes.LIVE_SESSION]: 'Live Session',
	[sessionTypes.HOMEWORK]: 'Student Paced',
	[sessionTypes.EMBED]: 'Embed',
	[sessionTypes.PREVIEW]: 'Preview',
	[sessionTypes.TEACHER_STUDENT_VIEW]: 'Teacher Student View',
	[sessionTypes.CANVAS]: 'Canvas',
	[sessionTypes.FRONT_OF_CLASSROOM]: 'Front of Classroom',
}

export default sessionTypes
